import { render, staticRenderFns } from "./CbsDataAttribute.vue?vue&type=template&id=64bbfaa4&scoped=true"
import script from "./CbsDataAttribute.vue?vue&type=script&lang=js"
export * from "./CbsDataAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bbfaa4",
  null
  
)

export default component.exports